'use strict';

function deInitialize($wrapper) {
  $wrapper.find('.k2-keyboard-input').removeClass('keyboard-init');
}

function initialize($wrapper, withDeInitialize) {
  if (withDeInitialize) {
    deInitialize($wrapper);
  }

  $wrapper.find('.char-counter').k2_charCounter();
  $wrapper.find('.panel-collapsible').k2_panelCollapsible();
}

$(document).ready(function () {
  initialize($('body'));

  $().k2_top();
});
